module.exports = __webpack_public_path__ + "assets/img/bitrise_workflow.7a789bcf.png";